import { ScrollReveal } from "./ScrollReveal";
import { Button } from "./ui/button";
import { motion } from "framer-motion";

const DemoBuildings = () => {
  const buildings = [
    { w: 60, h: 160, x: 280 },
    { w: 50, h: 200, x: 345 },
    { w: 70, h: 240, x: 400 },
    { w: 55, h: 180, x: 475 },
    { w: 65, h: 220, x: 535 },
    { w: 45, h: 150, x: 605 },
    { w: 75, h: 260, x: 655 },
    { w: 50, h: 190, x: 735 },
  ];

  return (
    <svg
      viewBox="0 0 800 280"
      className="absolute bottom-0 right-0 w-[65%] h-full"
      preserveAspectRatio="xMaxYMax meet"
    >
      <defs>
        <linearGradient id="demoBuildingGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="hsl(263 55% 45%)" />
          <stop offset="100%" stopColor="hsl(263 45% 28%)" />
        </linearGradient>
      </defs>
      {buildings.map((b, i) => (
        <g key={i}>
          <rect
            x={b.x}
            y={280 - b.h}
            width={b.w}
            height={b.h}
            fill="url(#demoBuildingGrad)"
            rx="2"
            stroke="hsl(263 60% 55% / 0.2)"
            strokeWidth="0.5"
          />
          {Array.from({ length: Math.floor(b.h / 30) }).map((_, row) =>
            Array.from({ length: Math.floor((b.w - 16) / 18) }).map(
              (_, col) => (
                <motion.rect
                  key={`${row}-${col}`}
                  x={b.x + 8 + col * 18}
                  y={280 - b.h + 15 + row * 30}
                  width="10"
                  height="8"
                  rx="1"
                  fill="#FBBF24"
                  initial={{ opacity: 0.15 }}
                  animate={{ opacity: [0.15, 0.8, 0.15] }}
                  transition={{
                    duration: 2 + Math.random() * 3,
                    repeat: Infinity,
                    delay: Math.random() * 2,
                  }}
                />
              ),
            ),
          )}
        </g>
      ))}
    </svg>
  );
};

const DemoSection = () => {
  return (
    <section id="demo" className="py-16 sm:py-24 section-light">
      <div className="container mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <div className="relative rounded-3xl overflow-hidden hero-dark min-h-[320px] sm:min-h-[380px] flex items-center">
            {/* Glow */}
            <div
              className="absolute top-1/3 left-1/4 w-[400px] h-[400px] rounded-full opacity-20"
              style={{
                background:
                  "radial-gradient(circle, hsl(263 47% 50% / 0.4), transparent 70%)",
              }}
            />

            <DemoBuildings />

            <div className="relative z-10 p-8 sm:p-12 lg:p-16 max-w-lg">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary-foreground leading-tight mb-3">
                We're a Partner,
                <br />
                Not just a Platform
              </h2>
              <p className="text-primary-foreground/50 text-sm mb-8 leading-relaxed max-w-sm">
                See how PRObroker can transform your brokerage with a
                personalized walkthrough.
              </p>
              <a href="/signup">
              <Button
                size="lg"
                className="!bg-amber-400 hover:!bg-amber-300 !text-black font-bold !rounded-xl h-12 px-10 text-sm shadow-lg"
              >
                BOOK A DEMO
              </Button>
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>  
  );
};

export default DemoSection;
